import { lang } from 'moment/moment';

export const DISCOUNTS = {
  TEACHER: 'TEACHER_DISCOUNT',
  SCHOOL: 'SCHOOL_DISCOUNT',
  JUNIOR: 'JUNIOR_DISCOUNT',
};

export const USER_ROLES = {
  TEACHER: 'teacher',
  STUDENT: 'student',
};

export const FOOTER_BUTTONS = {
  NEXT: 'Next',
  // SAVE_ACTIVITY: 'Save Activity',
  PREVIOUS: 'Previous',
  ADD_STEP: 'Add Step',
};

export const CONTENT_BUILDER = {
  NEW_STEP_ID: 'new',
  EXIT_ACTIVITY: 'Exit Activity',
};

export const RECENTLY_PUBLISHED = {
  COUNT: 3,
};
export const MARKDOWN_AUTOCOMPLETE_TYPES = {
  ATTRIBUTES: 'attributes',
  ICONS: 'icons',
  ALERTICONS: 'alert-icons',
};

export const CONTENT_LIBRARY = {
  DEFAULT_SUBJECT_CATEGORY: 'math',
  OTHER_SUBJECT_CATEGORY: 'other',
};

export const ERROR_MESSAGE = {
  GENERIC_API_FAILURE:
    "Sorry! Something went wrong, but we're looking into it.",
};

export const TUVA_JUNIOR_FILTER_TYPE = 'jr';
export const TUVA_JUNIOR_PRACTICE_FILTER_TYPE = 'jr-practice';
export const TUVA_JR_FEATURED_TAG = 'Featured Tuva Jr.';
export const TUVA_JR_FEATURED_CRITERIA_NAME = 'Featured Tuva Jr. Lessons';

export const TUVA_JUNIOR_SLUG = 'tuva-jr';
export const GOOGLE_AUTH_INSUFFICIENT_SCOPE = 'Insufficient Scope';

export const LESSON_TYPE_MAPPING = {
  datastory: 'Data Story',
  taskassessment: 'Assessment',
  task: 'Task',
  practice: 'Practice',
  CourseLesson: 'Lesson',
  lesson: 'Lesson',
  simulation: 'Sim Lesson',
  activity: 'Activity',
};

export const LESSON_TYPE_ICON = {
  datastory: 'ti-datastories',
  taskassessment: 'ti-assessments',
  task: 'ti-tasks',
  practice: 'ti-content-practice',
  simulation: 'ti-simulation',
};

export const USER_PREFERENCE_MAPPING = {
  dashboardPreferenceSubject: 'dashboardPreferenceSubject',
  tour: 'v1',
  // Separate key so the dashboard-v2 tour is tracked independently of the v1 tour.
  tourV2: 'v2',
  textSizePreference: 'text_size',
  keywordPreference: 'keywordPreference',
  textToSpeechSpeed: 'textToSpeechSpeed',
  languagePreference: 'languagePreference',
};

export const ELD_TOOLTIP =
  'Lesson supports English development for multilingual learners.';

export const CONTENT_LIBRARY_TAGS = [
  { slug: 'science', label: 'Science' },
  { slug: 'math', label: 'Math' },
  { slug: 'tuva-jr', label: 'Tuva Jr.' },
  { slug: 'assessment', label: 'Assessment' },
];

export const LANGUAGE_OPTIONS = [
  { value: 'Arabic', key: 'ar', toolsLang: 'ar-SD' },
  {
    value: 'Chinese (Simplified), Cantonese',
    key: 'zh-CN',
    toolsLang: 'cantonese',
  },
  {
    value: 'Chinese (Traditional), Mandarin',
    key: 'zh-TW',
    toolsLang: 'mandarin',
  },
  { value: 'English', key: 'en', toolsLang: 'en-US' },
  { value: 'French', key: 'fr', toolsLang: 'fr' },
  { value: 'German', key: 'de', toolsLang: 'de' },
  { value: 'Haitian Creole', key: 'ht', toolsLang: 'ht' },
  { value: 'Korean', key: 'ko', toolsLang: 'ko' },
  { value: 'Lithuanian', key: 'lt', toolsLang: 'lt' },
  { value: 'Portuguese', key: 'pt', toolsLang: 'pt' },
  { value: 'Spanish', key: 'es', toolsLang: 'es' },
  { value: 'Turkish', key: 'tr', toolsLang: 'tr' },
];

const Constants = {
  DISCOUNTS,
  USER_ROLES,
  FOOTER_BUTTONS,
  CONTENT_BUILDER,
  RECENTLY_PUBLISHED,
  MARKDOWN_AUTOCOMPLETE_TYPES,
  CONTENT_LIBRARY,
  ERROR_MESSAGE,
  TUVA_JUNIOR_FILTER_TYPE,
  TUVA_JUNIOR_PRACTICE_FILTER_TYPE,
  TUVA_JUNIOR_SLUG,
  GOOGLE_AUTH_INSUFFICIENT_SCOPE,
  LESSON_TYPE_MAPPING,
  LESSON_TYPE_ICON,
  TUVA_JR_FEATURED_TAG,
  TUVA_JR_FEATURED_CRITERIA_NAME,
  USER_PREFERENCE_MAPPING,
  ELD_TOOLTIP,
  LANGUAGE_OPTIONS,
  CONTENT_LIBRARY_TAGS,
};
export default Constants;
